// @ts-nocheck
import React from 'react';

import DashboardStats from './DashboardStats';

const DashboardStatsMini = (props) => {
  return <DashboardStats {...{ ...props, className: 'statsdashboard-mini' }} />;
};
export default DashboardStatsMini;
